const fr = {
  common: {
    loading: "Chargement...",
    close: "Fermer",
    submit: "Soumettre",
    review: "Revoir",
    help: "Aide",
    tour: "Tournée",
    instructions: "Instructions",
    language: "Langue",
    ok: "D'accord",
    appLoaderText:
      "Chargement... Veuillez patienter pendant que nous préparons votre environnement d'évaluation."
  },
  assessment: {
    fetchError: "Erreur lors de la récupération du {{featureName}}",
    somethingWentWrong: "Quelque chose s'est mal passé.",
    goBackToDashboard: "Revenir au tableau de bord",
    confirmSubmissionTitle: "Confirmer la soumission",
    scheduleIdNotFound: "Identifiant d'horaire introuvable",
    ongoingIdNotFound: "En cours Identifiant introuvable",
    errorFetchingOngoingData:
      "Erreur lors de la récupération des données en cours",
    connectionRestoredLabel: "Connexion rétablie.",
    connectionRestoredDescription:
      "Vous pouvez continuer à exécuter des scénarios de test.",
    connectionLostLabel: "Nous avons perdu la connexion au serveur de test.",
    connectionLostDescription:
      "Vous ne pourrez pas exécuter ou valider de cas de test pour le moment.",
    featureNames: {
      assessment: "Évaluation",
      knowledgeCheck: "Vérification des connaissances"
    },
    cardStatus: {
      na: "N/A",
      toBeLaunched: "À venir",
      expired: "Expirée",
      expiringSoon: "Expire bientôt",
      ongoing: "En cours"
    },
    cardState: {
      draft: "Brouillon",
      published: "Publié",
      cancelled: "Annulé",
      inreview: "En révision",
      readytopublish: "Prêt à publier",
      sentback: "Renvoyé"
    },
    dashboard: {
      videoProctoring: "Surveillance vidéo",
      submitFeature: "Soumettre {{featureName}}",
      noSectionsFound: "Aucune rubrique trouvée",
      expandAllSections: "Développer toutes les sections",
      closeAllSections: "Fermer toutes les sections",
      continueShapingAssessments: "Continuez à façonner vos évaluations",
      viewAll: "Voir tout",
      legend: {
        notStarted: "Non démarré",
        inProgress: "En cours",
        completed: "Complété"
      }
    },
    confirmModal: {
      description:
        "Une fois soumis, vous ne pourrez apporter aucune modification à votre {{featureName}}. Veuillez revoir vos réponses avant de confirmer. Voulez-vous procéder à la soumission?",
      lowWordCountWarning:
        "Votre réponse à la question {{questionTitle}} compte moins de 40 mots. Si vous soumettez l'évaluation maintenant, cette réponse ne sera pas enregistrée.",
      videoNotSubmittedWarning:
        "Votre vidéo enregistrée pour la question {{questionTitle}} n'est pas soumise. En soumettant l'évaluation maintenant, cette réponse sera rejetée.",
      unansweredQuestions: "Vous avez {{count}} questions sans réponse",
      andFlaggedQuestions: "et {{count}} questions signalées",
      failedToFinish: "Échec de la fin du {{featureName}}"
    },
    feedback: {
      submittedTitle: "Votre {{featureName}} a été soumis avec succès !",
      submittedDescription:
        "Vos réponses ont été soumises. Nous apprécions le temps et les efforts que vous avez consacrés à la réalisation de ce {{featureName}} !",
      resultInProgress:
        "Le résultat est en cours de calcul et cela peut prendre jusqu'à une minute. S'il vous plaît, attendez...",
      resultReady:
        "Le résultat est prêt ! Cliquez sur le bouton Afficher le résultat pour l'afficher.",
      resultDelayed:
        "Le calcul des résultats prend plus de temps que d'habitude. Veuillez contacter l'administrateur pour votre résultat.",
      showResult: "Afficher le résultat",
      redirectingToResult:
        "Redirection vers la page de résultats dans {{seconds}} secondes si vous ne cliquez pas sur le bouton Afficher le résultat",
      shareFeedbackTitle: "Partagez vos commentaires",
      shareFeedbackDescription:
        "Vos idées ouvrent la voie à la croissance. Montons de niveau ensemble !",
      errorSubmittingFeedback: "Erreur lors de la soumission des commentaires",
      feedbackSubmittedTitle: "Tout est prêt, les commentaires sont soumis !",
      feedbackSubmittedDescription:
        "Vos commentaires ont été soumis. Merci de nous aider à améliorer l'expérience {{featureName}} !",
      feedbackAlreadySubmittedTitle:
        "Tout est prêt, commentaires déjà soumis !",
      feedbackAlreadySubmittedDescription:
        "Il semble que vous ayez déjà soumis vos commentaires. Merci de nous aider à améliorer l'expérience {{featureName}} !"
    },
    page: {
      errorFetchingPreAssessmentData:
        "Erreur lors de la récupération des données de pré-évaluation",
      connectionRestoredLabel: "Connexion rétablie.",
      connectionRestoredDescription:
        "Synchronisation de vos dernières modifications...",
      offlineLabel: "On dirait que vous êtes hors ligne.",
      offlineDescription:
        "Les modifications ne seront pas synchronisées tant que vous ne vous reconnecterez pas"
    },
    question: {
      questions: "Questions",
      closeQuestionsPanel: "Fermer le panneau de questions",
      collapse: "Effondrement",
      sectionSummary: "Résumé de la section",
      sections: "Sections",
      toggleQuestionsPanel: "Basculer le panneau de questions",
      switchModal: {
        switchQuestionButton: "Changer de question",
        leaveHeading: "Êtes-vous sûr de vouloir partir ?",
        discardMessage:
          "Vous avez des modifications non enregistrées. Si vous modifiez la question, votre réponse sera définitivement supprimée.",
        saveChangesButton: "Enregistrer les modifications",
        saveHeading: "Voulez-vous enregistrer les modifications ?",
        saveBeforeSwitchMessage:
          "Vous avez des modifications non enregistrées. Souhaitez-vous les enregistrer avant de modifier la question ?"
      }
    },
    faq: {
      q1: {
        question: "Que dois-je faire avant de démarrer le {{featureName}} ?",
        firstSentence:
          "Veuillez vous assurer d'avoir complété les éléments suivants :",
        list: {
          item1: "Une connexion Internet stable",
          item2:
            "Une webcam et un microphone fonctionnels (si la surveillance vidéo est activée)",
          item3: "Un environnement calme et sans distraction",
          item4:
            "Si la surveillance vidéo est activée, vous serez invité à effectuer une vérification du système.",
          item5: "Lire et accepter les conditions générales"
        }
      },
      q2: {
        question:
          "Puis-je naviguer entre les questions ou les sections pendant le {{featureName}} ?",
        firstSentence: "La navigation dépend des paramètres.",
        list: {
          item1:
            "Si la navigation dans les sections est activée, vous pouvez vous déplacer entre les sections.",
          item2:
            "S'il est désactivé, vous devrez remplir une section avant de passer à la suivante."
        },
        lastSentence:
          "Les instructions seront disponibles à tout moment pendant le {{featureName}}."
      },
      q3: {
        question: "Serai-je surveillé pendant le test ?",
        list: {
          item1:
            "Si la surveillance vidéo est activée sur ce {{featureName}}, votre caméra et votre microphone seront utilisés.",
          item2: "Toute activité inhabituelle peut être signalée pour examen."
        }
      },
      q4: {
        question:
          "Que se passe-t-il si je perds la connexion Internet ou si je ferme accidentellement le navigateur ?",
        firstSentence: "Votre progression est automatiquement enregistrée.",
        lastSentence:
          "En cas de déconnexion, vous pouvez rejoindre le {{featureName}} en utilisant le même lien."
      },
      q5: {
        question:
          "Vais-je voir mes résultats ou mes commentaires après le test ?",
        firstSentence:
          "Les résultats et les commentaires sont configurés par l'organisateur {{featureName}}.",
        list: {
          item1:
            "Si cette option est activée, vous verrez votre score et votre résumé des commentaires après la soumission.",
          item2:
            "Dans le cas contraire, vos résultats seront partagés via votre adresse e-mail enregistrée."
        }
      }
    },
    labels: {
      totalDuration: "Durée totale",
      numberOfQuestions: "Nombre de questions",
      numberOfSections: "Nombre de sections",
      guidelines: "Lignes directrices",
      platformHelp: "Aide de la plateforme",
      faq: "FAQ",
      frequentlyAskedQuestions: "Foire aux questions",
      showFeatureInstructions: "Afficher les instructions {{featureName}}",
      minutes: "minutes",
      welcome: "Accueillir",
      welcomeBack: "Content de te revoir",
      userFallback: "Utilisateur",
      defaultGuidelines:
        "Avant de démarrer le {{featureName}}, assurez-vous que vous vous trouvez dans un espace calme, sans distraction et doté d'une connexion Internet stable. Gardez votre appareil photo allumé tout au long du test et gérez judicieusement votre temps car il y a une limite de temps. Si vous rencontrez des problèmes techniques, contactez immédiatement l'assistance. Une fois terminé, examinez vos réponses avant de les soumettre. Bonne chance!"
    },
    zoom: {
      textSize: "Taille du texte :",
      decreaseTextSize: "Diminuer la taille du texte (A-)",
      resetTextSize: "Réinitialiser la taille du texte (A)",
      increaseTextSize: "Augmenter la taille du texte (A+)",
      decreaseInterfaceSize: "Diminuer la taille de l'interface",
      resetInterfaceSize: "Réinitialiser la taille de l'interface",
      increaseInterfaceSize: "Augmenter la taille de l'interface"
    },
    wrapper: {
      warningTitle: "Avertissement!",
      stayOnPageMessage:
        "Veuillez rester sur cette page jusqu'à ce que vous ayez complété le {{featureName}}.",
      iUnderstand: "Je comprends",
      submitTheFeature: "Soumettre le {{featureName}}",
      videoProctoringInterrupted: "Surveillance vidéo interrompue",
      continuationBlocked:
        "La poursuite de l’évaluation est bloquée jusqu’à ce que la surveillance vidéo sécurisée soit rétablie.",
      retryProctoring: "Réessayer la surveillance"
    },
    progress: {
      proceed: "Procéder",
      resumeFeature: "Reprendre {{featureName}}",
      timeRemainingMessage:
        "restant dans le {{featureName}}. Cliquez ci-dessous pour reprendre là où vous vous étiez arrêté.",
      continueOnThisDevice: "Continuer sur cet appareil ?",
      switchToThisTab: "Passer à cet onglet ?",
      continueYourAssessmentHere: "Continuer votre évaluation ici ?",
      switchHere: "Changer ici",
      attemptsUnlimited:
        "Vous disposez d'un nombre illimité de tentatives pour cette évaluation.",
      attemptsSingle:
        "Vous disposez de <strong>1</strong> tentative disponible pour cette évaluation.",
      attemptsMultiple:
        "Vous disposez de <strong>{{remainingAttempts}}</strong> sur <strong>{{maxAttempts}}</strong> tentatives disponibles pour cette évaluation.",
      coolOffAfterAttempt:
        "Après chaque tentative, vous devrez attendre <strong>{{coolOffTime}}</strong> avant de commencer votre prochaine tentative."
    },
    loginWindow: {
      expiredTitle: "Temps de connexion expiré",
      expiredMessage:
        "La fenêtre de connexion pour ce {{featureName}} est maintenant fermée. Vous avez manqué le temps imparti pour accéder au test."
    },
    coding: {
      saving: "Économie",
      offlineTitle: "On dirait que tu es hors ligne",
      offlineDescription:
        "Les modifications ne seront pas synchronisées tant que vous ne vous reconnecterez pas",
      connectionRestored: "Connexion rétablie",
      syncingLatest: "Synchronisation de vos dernières modifications...",
      autoSaveEnabled: "Sauvegarde automatique activée",
      runOnlyChecksDescription:
        "vérifie uniquement votre code par rapport aux cas de test.",
      submitEvaluationDescription:
        "votre code pour qu'il soit évalué et pour recevoir une note.",
      reset: "Réinitialiser",
      run: "Exécuter",
      runTests: "Exécution de tests",
      submit: "Soumettre",
      submitting: "Soumission",
      resetCode: "Réinitialiser le code",
      resetCodeMessage:
        "Êtes-vous sûr de vouloir réinitialiser ? Cela supprimera tout votre code actuel et restaurera le code de démarrage",
      testCases: "Cas de test",
      testCase: "Scénario de test {{index}}",
      testCasePassed: "Cas de test réussi",
      testCaseFailed: "Échec du scénario de test",
      runtimeError: "Erreur d'exécution",
      timeLimitExceeded: "Délai dépassé",
      timeLimitExceededTitle: "Délai dépassé",
      timeLimitExceededDescription:
        "Votre code n'a pas été exécuté dans les délais. Veuillez optimiser votre code.",
      input: "Saisir",
      expectedOutput: "Résultat attendu",
      yourOutput: "Votre sortie",
      hiddenTestCase: "Cas de test caché",
      hiddenTestCaseDescription:
        "Les cas de test masqués sont utilisés pour évaluer si votre code peut gérer différents scénarios, y compris les cas extrêmes.",
      explanation: "Explication",
      hints: "Conseils"
    },
    subjective: {
      minWordsRequired:
        "Un minimum de 40 mots est requis pour soumettre la réponse.",
      enterYourAnswer: "Entrez votre réponse",
      submitResponse: "Soumettre la réponse",
      submittingResponse: "Envoi de la réponse...",
      resetAnswer: "Réinitialiser la réponse",
      resetAnswerMessage:
        "Êtes-vous sûr de vouloir réinitialiser ? Votre réponse actuelle sera supprimée définitivement.",
      retake: "Reprendre",
      showHint: "Afficher l'indice",
      recording: "ENREGISTREMENT"
    },
    systemCheck: {
      calibrate: "Étalonner",
      calibrating: "Calibrage...",
      accessDenied: "Accès refusé",
      cameraPermissionDenied:
        "Autorisation refusée pour la caméra. Veuillez activer l'accès à la caméra dans les paramètres de votre navigateur pour continuer.",
      errorFetchingDevices: "Erreur lors de la récupération des appareils",
      failedToStartAssessment: "Échec du démarrage de l'évaluation",
      unableToStartSecureProctoring:
        "Impossible de démarrer la surveillance sécurisée pour le moment. Veuillez réessayer.",
      unnamedCamera: "Caméra sans nom",
      facingCalibrationIssues:
        "Vous rencontrez des problèmes avec l'étalonnage vidéo ?",
      lookAtCenter:
        "Veuillez regarder le centre de l'écran et rester immobile.",
      unableToCalibrateTitle:
        "Impossible de calibrer votre caméra pour la surveillance vidéo ?",
      statusMessages: {
        readyForCalibration:
          "Assurez-vous que votre visage est clairement visible et centré sur l'écran. Lorsque vous êtes prêt, cliquez sur « Calibrer » pour commencer.",
        calibratingInProgress:
          "Calibrage en cours. Continuez à regarder l'écran.",
        calibratingTimedOut:
          "Le délai d'étalonnage de la caméra a expiré. Veuillez actualiser votre navigateur pour continuer.",
        preparingCameraPreview:
          "Préparation du flux de la caméra et du suivi du visage pour l'étalonnage.",
        retryRequired:
          "La configuration de surveillance nécessite votre action avant de continuer.",
        proctoringUnavailable:
          "La surveillance n'est actuellement pas disponible et l'évaluation ne peut pas démarrer en toute sécurité.",
        calibrationCompleted:
          "Calibrage réussi ! Vous êtes prêt à commencer l’évaluation.",
        timeoutHelp:
          "Si vous voyez toujours ce message, recherchez d'autres onglets/applications utilisant l'appareil photo ou un obturateur externe."
      },
      failureReasons: {
        cameraPermissionDenied:
          "L'autorisation de la caméra est bloquée. Autorisez l’accès et réessayez.",
        cameraUnavailable:
          "La caméra n'est pas disponible. Vérifiez la sélection de votre appareil et réessayez.",
        facemeshInitFailed:
          "La configuration du suivi du visage a échoué. Réessayez pour continuer.",
        cocoLoadFailed:
          "Le moteur de surveillance n'est pas disponible. Actualisez et réessayez.",
        streamLostReacquireFailed:
          "La récupération du flux de la caméra a échoué. Réessayez la surveillance.",
        calibrationInsufficientData:
          "Les échantillons d’étalonnage étaient insuffisants. Réessayez l’étalonnage.",
        detectionCadenceUnavailable:
          "La configuration du timing n'est pas prête. Réessayez sous peu."
      },
      calibrationInfo: {
        heading:
          "Pour calibrer avec succès votre vidéo, veuillez suivre ces étapes :",
        followUpHeading: "Si le problème persiste, procédez comme suit :",
        initialSteps: {
          step1: {
            title: "Assurer un bon éclairage",
            description:
              "Asseyez-vous dans un endroit bien éclairé avec votre visage clairement visible. Évitez la lumière vive ou les fenêtres derrière vous."
          },
          step2: {
            title: "Faites face directement à la caméra",
            description:
              "Placez votre visage au centre du cadre et regardez directement dans l'appareil photo pendant le calibrage."
          },
          step3: {
            title: "Évitez les arrière-plans sombres ou flous",
            description:
              "Assurez-vous que votre arrière-plan est clair et pas trop sombre."
          },
          step4: {
            title: "Vérifier les autorisations de la caméra",
            description:
              "Autorisez votre navigateur à accéder à la webcam lorsque vous y êtes invité."
          },
          step5: {
            title: "Reste immobile et regarde l'écran",
            description:
              "Gardez votre tête stable pendant l'étalonnage pour aider le système à détecter correctement votre visage."
          }
        },
        laterSteps: {
          step1: "Essayez d'actualiser la page et de recalibrer votre caméra.",
          step2:
            "Fermez d'autres applications à l'aide de la webcam (comme Zoom ou Teams).",
          step3:
            "Si le problème persiste, contactez {{contactEmail}} avec une capture d'écran de l'erreur."
        }
      }
    },
    stepper: {
      termsAndConditions: "Termes et conditions",
      agreeTerms: "J'ai lu et j'accepte les termes et conditions.",
      previousStep: "Étape précédente",
      nextStep: "Étape suivante",
      startAssessment: "Commencer l'évaluation",
      resumeAssessment: "Reprendre l'évaluation",
      mediaCheck: "Vérification des médias",
      systemCheck: "Vérification du système",
      audioCheck: {
        intro:
          "Vous pouvez enregistrer une courte vidéo ici pour vérifier que votre caméra et votre microphone fonctionnent comme prévu.",
        mediaPermissionDenied:
          "L'accès à la caméra ou au microphone a été refusé. Veuillez activer les autorisations dans les paramètres de votre navigateur.",
        startRecording: "Démarrer l'enregistrement",
        stopRecording: "Arrêter l'enregistrement",
        unnamedMicrophone: "Microphone sans nom"
      },
      stepLabel: "ÉTAPE {{step}}",
      personalDetails: "Détails personnels",
      emailId: "Identifiant de courrier électronique",
      firstName: "Prénom",
      lastName: "Nom de famille",
      defaultTncStatement:
        "En participant à cette évaluation, vous confirmez que vous remplissez les conditions d'éligibilité précisées par l'entreprise et acceptez de réaliser le test de manière indépendante, sans aide extérieure. L'évaluation est soumise à une surveillance vidéo et vous devez avoir votre caméra allumée tout au long de la séance dans un environnement sans distraction. Tous les contenus et documents fournis lors de l'évaluation sont confidentiels et ne doivent pas être partagés, reproduits ou distribués. Vous acceptez de respecter le délai imparti pour l'évaluation ; le fait de ne pas soumettre avant la date limite peut entraîner la disqualification. La société n'est pas responsable des problèmes techniques liés à votre connexion Internet, vos logiciels ou votre matériel. Les données personnelles collectées lors de l'évaluation seront traitées uniquement à des fins d'évaluation et de recrutement, conformément à la politique de confidentialité de l'entreprise. Toute tentative de tricher, de plagier ou de se livrer à un comportement contraire à l'éthique entraînera une disqualification immédiate. En soumettant vos réponses, vous confirmez qu'elles sont définitives et qu'aucune révision ne peut être apportée après la soumission. La société se réserve le droit de modifier ou de mettre à jour ces conditions à tout moment, et les participants seront informés de tout changement important.",
      okay: "D'accord"
    },
    access: {
      cancelledTitle: '"{{title}}" a été annulé',
      cancelledDescription:
        "Cette évaluation n’est plus active et n’est plus accessible. Veuillez consulter votre tableau de bord pour connaître les autres évaluations attribuées ou à venir.",
      goToHome: "Aller à la maison",
      refreshPage: "Actualiser la page"
    },
    errorPage: {
      goBack: "Retour",
      raiseRequest: "Créer une demande",
      retryLogin: "Réessayer la connexion",
      contactUs: "Contactez-nous",
      goBackToEvent: "Retour à l'événement",
      launchCourse: "Lancer le cours",
      created: "Créé",
      starts: "Débute",
      ends: "Se termine",
      untitled: "Sans titre"
    },
    sidebar: {
      home: "Accueil",
      quickAccess: "Accès rapide",
      questionPaperAuthoring: "Création de questionnaire",
      assessmentLibrary: "Bibliothèque d'évaluations",
      scheduleInterview: "Planifier un entretien",
      generateQuestions: "Générer des questions",
      roleManagement: "Gestion des rôles",
      logout: "Se déconnecter",
      noAccess: "Aucun accès",
      noAccessWithLabel: "{{label}} (Aucun accès)",
      noAccessToLink: "Vous n'avez pas accès à ce lien",
      expandSidebar: "Développer la barre latérale",
      collapseSidebar: "Réduire la barre latérale",
      expand: "Développer",
      collapse: "Réduire",
      myPreferences: "Mes préférences"
    },
    timesUp: {
      title: "Temps d'évaluation terminé",
      autoSubmittedMessage:
        "Le minuteur a expiré. Vos réponses ont été enregistrées et le {{featureName}} a été soumis automatiquement."
    },
    resultCard: {
      title: "{{featureName}} Résultats",
      score: "Score",
      passPercentage: "Pourcentage de réussite",
      marksAway:
        "Il vous manque {{count}} points pour obtenir la certification. Concentrez-vous sur les zones recommandées et réessayez.",
      certificationEarned:
        "Vous avez dépassé les exigences de certification et obtenu votre certification",
      congratulationsOnEarning:
        "Félicitations pour avoir obtenu la certification {{featureName}}",
      almostThereTitle:
        "Vous êtes plus près que vous ne le pensez d'obtenir la certification",
      certificatePassedDescription:
        "Vous avez démontré les connaissances et les compétences requises pour obtenir cette certification. Prenez un moment pour célébrer cet accomplissement et partagez-le avec votre réseau",
      certificateFailDescription:
        "Cette tentative a mis en évidence des opportunités de renforcer vos compétences. Passez en revue les zones recommandées et revenez en toute confiance",
      congratsImageAlt: "Félicitations",
      almostThereImageAlt: "J'y suis presque Image"
    },
    sectionCard: {
      section: "Section",
      startSection: "Section de démarrage",
      continueSection: "Continuer la section",
      completed: "Complété",
      viewSection: "Voir la section",
      totalQuestions: "Questions totales :",
      sectionNotFound: "Section introuvable.",
      total: "Total",
      flagged: "Marqué"
    },
    sectionSummary: {
      totalQuestions: "Nombre total de questions",
      completedQuestions: "Questions complétées",
      flaggedQuestions: "Questions signalées",
      unattemptedQuestions: "Questions non tentées",
      codingQuestions: "Questions de codage :",
      objectiveQuestions: "Questions objectives :",
      goToSections: "Aller aux rubriques",
      lowWordCountWarning:
        "Votre réponse à la question {{questionTitle}} compte moins de 40 mots. Si vous revenez à la liste des sections, cette réponse sera ignorée.",
      videoNotSubmittedWarning:
        "Votre vidéo enregistrée pour la question {{questionTitle}} n'est pas soumise. Si vous revenez à la liste des sections, cette réponse sera ignorée."
    },
    objective: {
      questionCounter: "Question",
      marks: "Marques :",
      explanation: "Explication",
      hints: "Conseils",
      reset: "Réinitialiser",
      flag: "Drapeau",
      unflag: "Supprimer le drapeau",
      previous: "Précédent",
      saveAndNext: "Enregistrer et suivant",
      saveAndViewSummary: "Enregistrer et afficher le résumé de la section",
      next: "Suivant",
      viewSectionSummary: "Voir le résumé de la section",
      hideExplanation: "Masquer l'explication",
      showExplanation: "Afficher l'explication",
      hintWaitTooltip: "Vous devez attendre avant de voir un autre indice",
      noHintsPendingTooltip: "Aucun indice n'est en attente",
      selectOptionForExplanation:
        "Sélectionnez l'option pour afficher l'explication de l'option sélectionnée"
    },
    tour: {
      shared: {
        timer:
          "Ce minuteur affiche le temps restant pour votre évaluation. Veuillez le surveiller de près pour vous assurer de terminer toutes les sections dans le temps imparti.",
        submit:
          "Une fois que vous avez terminé toutes les sections de l'évaluation, vous pouvez soumettre votre travail en cliquant sur le bouton « Soumettre l'évaluation ». Cette action finalise vos réponses et vous ne pourrez plus apporter de modifications une fois soumises. Assurez-vous d'avoir examiné toutes vos réponses avant de procéder à la soumission."
      },
      dashboard: {
        legend:
          "La légende de l'état de la section vous aide à comprendre vos progrès tout au long de l'évaluation. Il utilise des indicateurs clairs pour indiquer si une section n'a pas été commencée, est actuellement en cours ou est terminée. Cela vous permet d'évaluer rapidement les parties qui nécessitent encore votre attention et de gérer votre temps efficacement.",
        sectionCard:
          "La fiche de section fournit un aperçu détaillé de chaque section d’évaluation. Il affiche le titre de la section, son statut actuel et des informations clés sur les questions de la section. Cela inclut le nombre total de questions, le nombre de questions signalées et le nombre de questions qui ont été complétées. La fiche de section vous aide à suivre vos progrès et à identifier les domaines qui pourraient nécessiter plus d’attention."
      },
      coding: {
        titles:
          "En haut de la page, vous trouverez un affichage clair du titre de l'évaluation et du titre de la section. Cela vous aide à suivre votre tâche actuelle et garantit que vous connaissez la section spécifique sur laquelle vous travaillez. Référez-vous à ces titres pour rester orienté pendant que vous parcourez les questions.",
        sectionsButton:
          "Ce bouton vous permet de revenir facilement au tableau de bord des sections. Utilisez-le pour revenir à l'aperçu principal de votre évaluation, où vous pouvez visualiser et gérer la progression de toutes les sections. Il constitue un moyen rapide de réévaluer vos progrès globaux sans perdre aucun de vos travaux en cours.",
        sidebar:
          "La barre latérale fournit un aperçu de toutes les questions de la section actuelle que vous tentez. Il vous permet de naviguer rapidement entre les questions en sélectionnant simplement le bloc concerné. Chaque bloc de questions est codé par couleur en fonction de son statut, ce qui permet de suivre facilement vos progrès et de passer à des questions spécifiques si nécessaire.",
        questionCard:
          "Cette carte contient la question sur laquelle vous travaillez actuellement, affichant l'invite complète et toutes les instructions ou exigences de saisie pertinentes. Il est conçu pour vous donner une vision claire de la tâche à accomplir, avec toutes les informations nécessaires pour procéder. Vous trouverez également un bouton pour signaler la question pour un examen ultérieur, vous permettant ainsi de la revoir facilement si nécessaire. De plus, des boutons de navigation vous permettent de passer à la question suivante ou précédente sans revenir à la barre latérale, garantissant ainsi une progression fluide et efficace dans l'évaluation.",
        editor:
          "L'éditeur de code est l'endroit où vous écrirez et modifierez vos solutions. Vous pouvez basculer entre différents langages de programmation pour répondre aux exigences de chaque question. De plus, vous avez la possibilité d'ajuster le thème de l'éditeur pour une expérience de codage plus confortable. Si vous préférez plus d'espace à l'écran, l'éditeur peut être étendu sur toute la largeur, vous offrant ainsi une plus grande zone de travail. Ces fonctionnalités sont conçues pour fournir un environnement flexible et convivial lorsque vous effectuez vos tâches de codage."
      }
    },
    toast: {
      proctoringViolationDetected: "Violation de surveillance détectée",
      messages: {
        forbiddenObjectDetected: "Objet interdit détecté",
        noFaceDetected: "Aucun visage détecté",
        multipleFacesDetected: "Plusieurs visages détectés",
        lookingAwayFromScreen: "Regarder loin de l'écran",
        notLookingAtScreen: "Je ne regarde pas l'écran",
        faceNotOrientedCorrectly: "Visage mal orienté",
        eyesNotFullyOpen: "Les yeux pas complètement ouverts",
        copyNotAllowed: "La copie n'est pas autorisée",
        cutRestricted: "La coupe est restreinte en mode surveillance",
        pasteNotAllowed: "Le collage n'est pas autorisé",
        contextMenuNotAllowed:
          "L'ouverture du menu contextuel n'est pas autorisée"
      }
    },
    whatsNext: {
      heading: "Quelle est la prochaine étape ?",
      attemptsRemaining: "tentatives restantes",
      passed: {
        shareLinkedInTitle: "Partager sur LinkedIn",
        shareLinkedInSubtitle:
          "Célébrez votre réussite avec votre réseau professionnel.",
        viewCertificateTitle: "Afficher le certificat",
        viewCertificateSubtitle:
          "Téléchargez ou accédez à votre certification à tout moment.",
        shareGloTitle: "Partager l'expérience",
        shareGloSubtitle:
          "Inspirez vos collègues en publiant vos réalisations en interne."
      },
      failed: {
        reviewLearningResourcesTitle: "Examiner les ressources d'apprentissage",
        reviewLearningResourcesSubtitle:
          "Renforcez la compétence qui nécessite une attention particulière.",
        retakeAssessmentTitle: "Repasser l'évaluation",
        retakeAssessmentSubtitle:
          "Démontrez vos progrès et votre compréhension actualisée."
      },
      modal: {
        title: "Partager la réussite",
        linkedInPostLabel: "Partager sur LinkedIn sous forme de publication",
        linkedInProfileLabel: "Ajouter comme certification au profil LinkedIn",
        gloLabel: "Partager sur Glo",
        comingSoon: "À venir",
        infoMessage: "Vous devez être connecté à la plateforme pour partager."
      }
    },
    time: {
      hour_one: "{{count}} heure",
      hour_other: "{{count}} heures",
      minute_one: "{{count}} minute",
      minute_other: "{{count}} minutes",
      hourShort: "h",
      minuteShort: "min",
      secondShort: "s"
    },
    accessScreens: {
      attemptResultProcessing: {
        alt: "Les résultats {{featureName}} sont en cours de traitement",
        title: "Vos résultats sont en cours de traitement",
        description:
          "Nous sommes toujours en train d'examiner votre {{featureName}}. Veuillez revenir sous peu !"
      },
      coolOffPeriod: {
        alt: "Période de réflexion",
        title: "Prochaine tentative bientôt disponible",
        completedAttempt: "Vous avez déjà effectué une tentative pour cela",
        nextAttemptIntro: ". Votre prochaine tentative sera disponible dans"
      },
      maxAttemptExceeded: {
        alt: "Nombre maximal de tentatives atteint",
        title: "Nombre maximal de tentatives atteint",
        description:
          "Vous avez utilisé toutes les tentatives disponibles pour ce {{featureName}}. Aucune autre tentative ne peut être effectuée."
      },
      scheduleNotStarted: {
        alt: "Planification non démarrée",
        title: "{{featureName}} Pas encore commencé",
        scheduledPrefix: "Le",
        scheduledOn: "devrait commencer le",
        checkBack:
          "Veuillez vérifier à nouveau dans {{time}} ou actualiser une fois l'heure commencée."
      },
      scheduleTimeCompleted: {
        alt: "Heure programmée terminée",
        title: "{{featureName}} Fenêtre fermée",
        description:
          "L'heure prévue pour ce {{featureName}} est dépassée. Vous ne pouvez plus démarrer ou soumettre une tentative."
      }
    },
    attemptDetails: {
      allAttempts: "Toutes les tentatives",
      headers: {
        attempt: "Tentative",
        attemptedOn: "Tentative sur",
        percentage: "Pourcentage"
      },
      viewAllAttempts: "Afficher toutes les tentatives"
    },
    survey: {
      questions: {
        q1: "Sur une échelle de 1 à 5, dans quelle mesure avez-vous trouvé les questions {{featureName}} claires ?",
        q2: "Je me sentais suffisamment préparé pour les sujets abordés dans le {{featureName}}",
        q3: "La plateforme utilisée pour le {{featureName}} était conviviale et fonctionnelle",
        q4: "Je pense que mes réponses ont efficacement mis en valeur mes compétences et mes connaissances."
      },
      stronglyDisagree: "Fortement en désaccord",
      stronglyAgree: "Tout à fait d'accord",
      submitFeedback: "Envoyer des commentaires"
    },
    cameraPreview: {
      loadingAlt: "Chargement de l'aperçu de la caméra",
      delayedMessage:
        "L'étalonnage prend plus de temps que prévu en raison d'un réseau lent. Veuillez patienter ou essayer d'actualiser la page."
    },
    proctoring: {
      engineLoadFailedStatus: "Le moteur de surveillance n'a pas pu se charger",
      runtimeErrors: {
        cameraPermissionDenied:
          "L'accès à la caméra est bloqué par les paramètres d'autorisation du navigateur.",
        cameraUnavailable:
          "La caméra n'est pas disponible ou est actuellement utilisée par une autre application.",
        unableToLoadModel:
          "Impossible de charger le modèle de détection d'objet de surveillance.",
        webglRecoveryFailed:
          "La récupération WebGL a échoué lors de la restauration de la détection d'objet."
      },
      logs: {
        engineLoadFailed: "ProctoringEngine n'a pas réussi à charger :",
        videoPlayRejected: "Lecture vidéo() rejetée :",
        cameraTrackEnded:
          "Piste de caméra terminée - tentative de réacquisition",
        cameraReacquired: "Caméra réacquise lors de la tentative {{attempt}}",
        cameraReacquireAttemptFailed:
          "La tentative de réacquisition de la caméra {{attempt}} a échoué :",
        cameraReacquireFailedAll:
          "La réacquisition de la caméra a échoué après toutes les tentatives - rapport de caméra déconnectée à chaque cycle",
        uploadFailedQueued:
          "Échec de l'importation de surveillance après {{attempts}} tentatives, mise en file d'attente pour une nouvelle tentative :",
        uploadAttemptFailedRetrying:
          "La tentative de téléchargement de surveillance {{attempt}} a échoué. Nouvelle tentative...",
        drainedQueuedViolation:
          "Violation de la file d'attente drainée : {{violationType}} ({{remaining}} restant)",
        queueDrainFailed:
          "Échec de la vidange de la file d'attente. Nous réessayerons le cycle suivant :",
        cocoLoadFailed: "Échec du chargement du COCO-SSD :",
        faceProcessingError: "Erreur de traitement du visage :",
        errorProcessingFrame: "Trame de traitement des erreurs :",
        faceMeshInitError: "Erreur d'initialisation de Face Mesh :"
      }
    }
  }
} as const;

export default fr;
